<template>
  <div class="kw_list_progress">
    <div class="totalProgress">
        <div class="currentProgress" :style="'width:'+(nowWidthNum)+'%'"></div>
    </div>
    <div class="selectionProgress">
        <div v-for="(dataInfo,dataIndex) in dataList" :key="dataIndex" class="selItem" :style="'width:'+(dataInfo.Percentage)+'%'">
          <div v-if="dataInfo.BG_FILE" :class="'poptit '+(dataIndex%2==1?'poptit_bottom':'currentpop')" :style="dataIndex==0?'left:30px;':''">
            <img v-if="dataInfo.BG_FILE" :src="GLOBAL.getFileServeUrl()+dataInfo.BG_FILE"/>
          </div>
          <div v-else class="poptit poptit_bottom" :style="dataIndex==0?'left:30px;':''">
            {{dataInfo.NAME}}
          </div>
            {{dataInfo.NUM}}
        </div>
    </div>
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';

export default {
  name: 'kw_list_progress',
  props: {
    pageSetInfo: {
      type: Object,
      value: null
    },
    listFieldSet: {
      type: Array,
      value: null
    },
    //列表数据全部显示
    dataList: {
      type: Array,
      value: null
    },
    //单一一条数据进行显示
    dataInfo: {
      type: Object,
      value: null
    },
    initDataIndex: {
      type: Number,
      value: 0
    }
  },
  data() {
    return {
      nowWidthNum:100,
      width: 670
    };
  },
  created() {
    //选择id
    var that = this;
    var dataList = that.dataList;
    var width = that.width;
    // 获取最后一条数据 进行百分比的计算
    if (dataList.length>0) {
      var dataOne = dataList[dataList.length - 1];
      dataList.forEach(i=>{
        var p = (i.NUM / dataOne.NUM)*100;
        i.Percentage = p.toFixed(2);
        console.log(i)
      })
      var nowWidthNum = dataOne.NOW_NUM / dataOne.NUM;
      that.dataList = dataList;
      that.nowWidthNum = nowWidthNum;
    }
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
  },
  methods: {
    /**
     * 列表数据点击时 进行跳转
     */
    listDataClick(dataInfo) {
      pageUtils.listDataClick(this, dataInfo);
    },
    /**
     * 列表按钮点击事件
     */
    dataButtonClick: function (detail,dataInfo) {
      pageUtils.dataButtonClick(this,detail,dataInfo);
    },
    /**
     * 调用列表数据刷新方法
     */
    initLoadDataInfo: function () {
      this.$emit("refreshevent");
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.totalProgress {
    width:100%;
    height:10px;
    background:#F0F0F0;
    border-radius: 8px;
    margin-top:55px;
}

.currentProgress {
    width:30%;
    height:100%;
    background:#FEB834;
    border-radius: 8px;
}

.selectionProgress {
    position:relative;
}

.selectionProgress .selItem {
    font-size: 12px;
    color:#0E0E0E;
    line-height:1.5;
    text-align: right;
    position:absolute;
}

.selectionProgress .selItem:nth-child(1) {
    width:0%;
}

.selectionProgress .selItem:nth-child(2) {
    width:15.15%;
}

.selectionProgress .selItem:nth-child(2):before,
.selectionProgress .selItem:nth-child(3):before,
.selectionProgress .selItem:nth-child(4):before,
.selectionProgress .selItem:nth-child(5):before{
    content: ' ';
    display: block;
    width:1px;
    height:5px;
    background: #A6A6A6;
    position: absolute;
    top: -5px;
    right: 10px;
}

.selectionProgress .selItem:nth-child(3) {
    width:23.23%;
}

.selectionProgress .selItem:nth-child(4) {
    width:40.67%;
}

.selectionProgress .selItem:nth-child(5) {
    width:60.6%;
}

.selectionProgress .selItem:nth-child(6) {
    width:100%;
}

.poptit {
    position: absolute;
    top:-60px;
    left: 100%;
    transform: translate(-40px);
    width:60px;
    height:30px;
    border:1px solid #DFDFDF;
    border-radius: 5px;
    text-align: center;
    line-height: 30px;
}

.poptit img {
    width: 30px;
    height: 24px;
    position: absolute;
    left: 50%;
    top: 3px;
    transform: translate(-15px);
}

.poptit_bottom {
    top: 30px;
}

.selectionProgress .selItem:last-child .poptit {
    transform: translate(-58px);
}

.poptit:before {
    content: ' ';
    display: block;
    width:10px;
    height:10px;
    background:#fff;
    border:1px solid #DFDFDF;
    border-top:none;
    border-right:none;
    position:absolute;
    bottom:-2px;
    left:45%;
    transform: rotate(-45deg) translate(-5px);
}

.poptit_bottom:before {
    top: -5px;
    left: 38%;
    transform: rotate(135deg);
}

.currentpop {
    border:1px solid #FEB834;
}

.currentpop:before {
    border:1px solid #FEB834;
    border-top:none;
    border-right:none;
}

</style>
